// extracted by mini-css-extract-plugin
export var layoutContainer = "_99-0";
export var layoutContainerNoRounding = "_99-6";
export var layoutContainerOpen = "_99-5";
export var layoutContainerResizing = "_99-1";
export var mainContent = "_99-2";
export var resizeDivider = "_99-3";
export var slidePanel = "_99-4";